import type { CMSAccordionDTO } from "~/features/cms/types/dto";
import { renderCMSComponent } from "~/features/cms/componentFactory";
import { Accordion, AccordionDetails, AccordionSummary } from "~/common/mui";

interface Props extends Omit<CMSAccordionDTO, "type"> {
  className?: string;
}

export const CMSAccordion = (props: Props) => {
  return (
    <Accordion defaultExpanded={props.openByDefault} slots={{ heading: "h3" }}>
      <AccordionSummary>{props.title}</AccordionSummary>
      <AccordionDetails>
        {props.accordionBody.map((content, index) => {
          return renderCMSComponent(content, undefined, index);
        })}
      </AccordionDetails>
    </Accordion>
  );
};
